import React from "react";
import { inject, observer } from "mobx-react";
import { Input, Form } from "antd";
import { IAppStore } from "stores/Interfaces";
import { FieldConfig } from "components/common/forms/Interfaces";

interface Props {
  value: string;
  store?: IAppStore;
  name: string;
  config?: FieldConfig;
}

const TextArea: React.FC<Props> = ({ store, value, name, config, ...rest }) => {
  return (
    <Form.Item
      name={name}
      label={config?.label}
      rules={config?.validationRules}
      labelCol={{ span: 24 }}
      style={{ marginBottom: 0 }}
      {...(config?.extra || {})}
      {...rest}
    >
      <Input.TextArea defaultValue={value} key={name} style={{ height: 40 }} />
    </Form.Item>
  );
};

export default inject("store")(observer(TextArea));
